<div class="sidebar-menu">
    <section>
        <fa-icon
            matTooltipPosition="after"
            size="xl"
            [class.active]="panelService.currentPanel() === ActionsEnum.LAYER"
            [icon]="['fas', ActionsEnum.LAYER]"
            [matTooltip]="'layer' | transloco: { COUNT: 2 }"
            (click)="navigateToNewPage(ActionsEnum.LAYER, RoutePathEnum.LAYERS)" />
        <fa-icon
            matTooltipPosition="after"
            size="xl"
            [class.active]="panelService.currentPanel() === ActionsEnum.STATISTICS"
            [class.disabled]="!hasStatisticPermissions()"
            [icon]="['fas', ActionsEnum.STATISTICS]"
            [matTooltip]="'statistics' | transloco"
            (click)="
                hasStatisticPermissions()
                    ? navigateToNewPage(ActionsEnum.STATISTICS, RoutePathEnum.STATISTICS)
                    : $event.stopPropagation()
            " />
        <fa-icon
            matTooltipPosition="after"
            size="xl"
            [class.active]="panelService.currentPanel() === ActionsEnum.SYNOPTIC"
            [class.disabled]="!canOpenSynoptic()"
            [icon]="['fas', ActionsEnum.SYNOPTIC]"
            [matTooltip]="'synoptic.title' | transloco"
            (click)="canOpenSynoptic() ? openSynoptic() : $event.stopPropagation()" />
        <fa-icon
            matTooltipPosition="after"
            size="xl"
            [class.active]="panelService.currentPanel() === ActionsEnum.AI"
            [class.disabled]="!hasAiAccess()"
            [icon]="['far', ActionsEnum.AI]"
            [matTooltip]="'ai' | transloco"
            (click)="!hasAiAccess() ? $event.stopPropagation() : navigateToNewPage(ActionsEnum.AI, RoutePathEnum.AI)" />
    </section>
    <div class="sep"></div>
    <section>
        <fa-icon
            matTooltipPosition="after"
            size="xl"
            [class.active]="panelService.currentPanel() === ActionsEnum.FIELD_INTERVENTION"
            [class.disabled]="!hasInterventionPermissions()"
            [icon]="['fas', ActionsEnum.FIELD_INTERVENTION]"
            [matTooltip]="'intervention' | transloco: { COUNT: 2 }"
            (click)="
                hasInterventionPermissions()
                    ? navigateToNewPage(ActionsEnum.FIELD_INTERVENTION, RoutePathEnum.FIELD_INTERVENTIONS)
                    : $event.stopPropagation()
            " />
    </section>
    <div class="sep"></div>
    <section>
        <fa-icon
            matTooltipPosition="after"
            size="xl"
            [class.active]="panelService.currentPanel() === ActionsEnum.SETTINGS"
            [class.disabled]="!hasSettingsPermissions()"
            [icon]="['fas', ActionsEnum.SETTINGS]"
            [matTooltip]="'settings' | transloco"
            (click)="
                !hasSettingsPermissions()
                    ? $event.stopPropagation()
                    : navigateToNewPage(ActionsEnum.SETTINGS, RoutePathEnum.SETTINGS)
            " />
    </section>
</div>
